var map = {
	"./033-bm.webp": 1271,
	"./033-cn.webp": 1272,
	"./033.webp": 1273,
	"./13-bm.webp": 1274,
	"./13-cn.webp": 1275,
	"./13.webp": 1276,
	"./3-bm.webp": 1277,
	"./3-cn.webp": 1278,
	"./3.webp": 1279,
	"./angpao-bg-mobile.webp": 1280,
	"./angpao-bg.webp": 1281,
	"./angpao-bm.webp": 1282,
	"./angpao-cn.webp": 1283,
	"./angpao.webp": 1284
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1270;